export default class DataLayer {

    static createEcommerceEvent(event, items) {
        if (typeof window !== 'undefined') {
            let dataLayer = window.dataLayer || [];

            this.clearEcommerce();

            dataLayer.push({
                'event': event,
                'ecommerce': 
                    {
                        'items': items
                    }
            });
        };
    }
    
    static createEcommercePaymentEvent(event, total, item) {
        if (typeof window !== 'undefined') {
            let dataLayer = window.dataLayer || [];

            this.clearEcommerce();

            let ecommerce = {
                'currency': item[0].currency,
                'value': total,
                'items': item
            };

            event === 'add_payment_info' ? 
                ecommerce['payment_type'] = "Credit Card" :
                ecommerce['shipping_tier'] = "Ground";
            dataLayer.push({
                'event': event,
                'ecommerce': ecommerce
            });
        };
    }

    static createEcommercePurchaseEvent(event, total, id, item, tax, type) {
        if (typeof window !== 'undefined') {
            const utm = this.getUtmSource();
            const org_affiliation = 
                (window && window.location && window.location.hostname) ? window.location.hostname : '';
            let dataLayer = window.dataLayer || [];

            this.clearEcommerce();

            dataLayer.push({
                'event': event,
                'ecommerce': 
                    {
                        'transaction_id': id,
                        'affiliation': utm ? utm : org_affiliation,
                        'tax': tax,
                        'currency': 'USD',
                        'value': total,
                        'payment_type': type,
                        'items': item,
                    }
            });
        };
    }

    static setUtmSource(_value) {
        const now = new Date();
        const item = {
            value: _value,
            expiry: now.getTime() + 2592000000, // Set Expiration 30 Days From Today
        };

        localStorage.setItem('analytics_utm_source', JSON.stringify(item));
    }
    
    static getUtmSource = () => {
        let utm_source = (typeof window !== 'undefined' && window.location && window.location.search && window.location.search.indexOf('utm_source') >= 0) ? window.location.search.match(/utm_source=([^&]*)/)[1] : null;

        if (utm_source) {
            this.setUtmSource(utm_source);
        }
        else {
            const utm_source_object = (typeof localStorage !== 'undefined') ? localStorage.getItem('analytics_utm_source') : null;

            if (utm_source_object) {
                const utm_json = JSON.parse(utm_source_object);
                const now = new Date();
                
                if (now.getTime() > utm_json.expiry) {
                    localStorage.removeItem('analytics_utm_source');
                }
                else {
                    utm_source = utm_json.value;
                };
            };
        };

        return (utm_source) ? utm_source : 'direct';
    }

    static clearEcommerce () {
        let dataLayer = window.dataLayer || [];
        dataLayer.push({ ecommerce: null });
    }
}